import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { shape } from './shape';
import { components } from './components';
import { layout, type AppLayout } from './layout';

// The IP risk color scale (see palette.risk). One entry per currentRisk level.
interface RiskPalette {
  unrated: string;
  suspicious: string;
  high: string;
}

// DS surfaces MUI has no slot for (see palette.surface).
interface SurfacePalette {
  chipFill: string;
  tooltip: string;
  blue100: string;
}

// Make the fixed layout dimensions + risk palette available on the theme everywhere.
declare module '@mui/material/styles' {
  interface Theme {
    layout: AppLayout;
  }
  interface ThemeOptions {
    layout?: AppLayout;
  }
  interface Palette {
    risk: RiskPalette;
    surface: SurfacePalette;
  }
  interface PaletteOptions {
    risk?: RiskPalette;
    surface?: SurfacePalette;
  }
  // Two more surfaces MUI has no slot for: the sidebar/drawer (Figma
  // background/tertiary, distinct from paper) and the chat's own message bubble
  // (background/quaternary).
  interface TypeBackground {
    tertiary: string;
    quaternary: string;
  }
}

export const theme = createTheme({
  palette,
  typography,
  shape,
  components,
  layout,
});
